<template>
    <el-dialog title="导入设备" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" width="300px">
        <el-upload :loading="loading" class="upload-demo btn" action="string" :accept="'.xlsx, .xls'" :before-upload="beforeUpload" :on-error="onError" :show-file-list="false" :http-request="onSuccess">
            <el-button type="primary" icon="el-icon-plus" class="btn">导入设备</el-button>
        </el-upload>
        <el-link icon="el-icon-download" style="margin-top: 30px;" href="https://hst-ybwifi.oss-cn-beijing.aliyuncs.com/template/%E8%AE%BE%E5%A4%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx">下载导入模板</el-link>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import WifiApi from '@/api/wifi.js'
export default {
    props: ['message', 'curId'],
    data() {
        return {
            loading: false,
            dialogFormVisible: false
        }
    },
    methods: {
        // 关闭组件
        handleCancel() {
            this.dialogFormVisible = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        beforeUpload(file) {
            const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const isXls = file.type === 'application/vnd.ms-excel'

            if (!isXlsx && !isXls) {
                this.$message.error('只能上传xlsx和xls格式的文件')
                return false
            } else {
                this.file = file
            }
        },
        onSuccess() {
            this.loading = true
            const formData = new FormData()
            formData.append('file', this.file)
            WifiApi.importDevice(formData).then(res => {
              this.$message.success(res.data)
              this.dialogFormVisible = false // 关闭弹窗
              this.loading = false
              this.$emit('add-success', this.dialogFormVisible) // 传递数据给父组件
            }).catch(e => {
                this.loading = false
            })
        },
        onError(err, file, fileList) {
            this.$message.error('上传失败！')
        },
    },
    mounted() {
    },
    watch: {
        message(newVal) {
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        }
    }
}
</script>

<style scoped>
.ml {
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/ybwifi/device/components/ImportDevice.vue